<template>
  <div class="speaker text-muted">{{speaker}}</div>
</template>
<script>
  export default {
    props: ['document', 'text'],
    computed: {
      speaker() {
        const { speaker } = this.text
        if (speaker === '(A)') return

        const number = speaker.replaceAll(/\D/g, '')
        return speaker.match(/\(T\d?\)/) ? `Teacher ${number}` : `Student ${number}`
      }
    }
  }
</script>
